import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openFptFromTraslado, openFptReadOnlyFromTraslado } from "../../trasladosVisualizarUtils";
import { buscarTrasladosPT, getTrasladosSearchModel, agregarObservacionPT, getObservacionesPT, rechazarTramoPT, marcarPosibleNegativoPT, getMotivosRechazoPT, getMotivosNegativoPT, exportarTrasladosPT } from "../../../../../../actions/traslados";
import BuscarTramosTablePT from "./buscarTramosTablePT";
import { downloadFile } from "../../../../../../utils/filesUtils";
import { convertDateTimeToNet } from "../../../../../../utils/datetimeUtils";
import ObservacionesDialogPT from "./observacionesDialogPT";
import RechazarDialogPT from "./rechazarDialogPT";
import MarcarNegativoDialogPT from "./marcarNegativoDialogPT";
import snackbarUtils from "../../../../../../utils/snackbarUtils";
import FormContainer from "../../../../forms/formContainer";

const BuscarTramosContainerPT = () => {
  const dispatch = useDispatch();
  const artContext = useSelector((state) => ({
    idArt:
      state.auth.artAsociada?.id ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.id,
    artName:
      state.auth.artAsociada?.nombre ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.nombre,
  }));

  const initialFilters = {
    nroSiniestro: "",
    documentoTrabajador: "",
    trabajador: "",
    estadoTramoId: "",
    datePeriod: "all",
    fechaDesde: null,
    fechaHasta: null,
    provinciaOrigen: "",
    localidadOrigen: "",
    provinciaDestino: "",
    localidadDestino: "",
    nroTramoUnico: "",
    sentido: "Todos"
  };

  const [filters, setFilters] = useState(initialFilters);

  const busquedaState = useSelector((state) => state.traslados.busqueda) || { isFetching: false, data: [] };
  const observacionesState = useSelector((state) => state.traslados.observacionesTramo) || { isFetching: false, data: [] };
  const motivosRechazoState = useSelector((state) => state.traslados.motivosRechazoPT) || { isFetching: false, data: [] };
  const motivosNegativoState = useSelector((state) => state.traslados.motivosNegativoPT) || { isFetching: false, data: [] };
  const motivosRechazo = motivosRechazoState.data;
  const motivosNegativo = motivosNegativoState.data;

  const [obsOpen, setObsOpen] = useState(false);
  const [rechazarOpen, setRechazarOpen] = useState(false);
  const [negativoOpen, setNegativoOpen] = useState(false);
  const [selectedTramo, setSelectedTramo] = useState(null);

  useEffect(() => {
    dispatch(getTrasladosSearchModel());
    dispatch(getMotivosRechazoPT());
    dispatch(getMotivosNegativoPT());
    handleSearch(initialFilters);
  }, [dispatch]);

  const buildPTPayload = (values) => {
    const payload = { ...(values || initialFilters) };
    delete payload.datePeriod;

    if (payload.sentido === "Todos") payload.esRetorno = null;
    else if (payload.sentido === "Ida") payload.esRetorno = false;
    else if (payload.sentido === "Vuelta") payload.esRetorno = true;
    delete payload.sentido;

    for (let key in payload) {
      if (payload[key] === "") payload[key] = null;
    }

    payload.fechaDesde = payload.fechaDesde ? convertDateTimeToNet(payload.fechaDesde) : null;
    payload.fechaHasta = payload.fechaHasta ? convertDateTimeToNet(payload.fechaHasta) : null;

    return payload;
  };

  const handleSearch = (values) => {
    const searchValues = values || initialFilters;
    setFilters(searchValues);
    const payload = buildPTPayload(searchValues);
    dispatch(buscarTrasladosPT(payload));
  };

  const handleClear = () => {
    setFilters(initialFilters);
    handleSearch(initialFilters);
  };

  const handleOpenObservaciones = (tramo) => {
    setSelectedTramo(tramo);
    setObsOpen(true);
    dispatch(getObservacionesPT(tramo.idTramo));
  };

  const handleSubmitObservacion = (values) => {
    try {
      dispatch(agregarObservacionPT(selectedTramo.idTramo, values.observacion)).then(() => {
        snackbarUtils.success("Observación agregada.");
      });
      setObsOpen(false);
      handleSearch(filters);
    } catch (e) {
      snackbarUtils.error("Error al agregar observacion.");
    }
  };

  const handleOpenRechazar = (tramo) => {
    setSelectedTramo(tramo);
    setRechazarOpen(true);
  };

  const handleSubmitRechazar = async (values) => {
    try {
      await dispatch(rechazarTramoPT(selectedTramo.idTramo, values.idMotivo, values.observaciones));
      snackbarUtils.success("Tramo rechazado.");
      setRechazarOpen(false);
      handleSearch(filters);
    } catch (e) {
      snackbarUtils.error("Error al rechazar tramo.");
    }
  };

  const handleOpenNegativo = (tramo) => {
    setSelectedTramo(tramo);
    setNegativoOpen(true);
  };

  const handleSubmitNegativo = async (values) => {
    try {
      await dispatch(marcarPosibleNegativoPT(selectedTramo.idTramo, values.horaLlegada, values.idMotivo, values.observaciones, values.imagenes));
      snackbarUtils.success("Marcado como posible negativo.");
      setNegativoOpen(false);
      handleSearch(filters);
    } catch (e) {
      snackbarUtils.error("Error al marcar posible negativo.");
    }
  };

  const [isExporting, setIsExporting] = useState(false);
  const handleExportar = () => {
    setIsExporting(true);
    const payload = buildPTPayload(filters);
    dispatch(exportarTrasladosPT(payload)).then((response) => {
      downloadFile(response.value.data, "Exportacion_Tramos_PT.csv");
    }).catch(() => {
      snackbarUtils.error("Error al exportar los tramos.");
    }).finally(() => {
      setIsExporting(false);
    });
  };

  const handleVisualizarTraslado = (tramo) => {
    openFptFromTraslado(dispatch, tramo, openFptReadOnlyFromTraslado, artContext);
  };

  return (
    <>
      <BuscarTramosTablePT
        filters={filters}
        onSearch={handleSearch}
        onClear={handleClear}
        results={busquedaState.data || []}
        loading={busquedaState.isFetching}
        onExportar={handleExportar}
        isExporting={isExporting}
        onVisualizarTraslado={handleVisualizarTraslado}
        onCargarObservaciones={handleOpenObservaciones}
        onRechazarTraslado={handleOpenRechazar}
        onMarcarPosibleNegativo={handleOpenNegativo}
      />
      <ObservacionesDialogPT
        open={obsOpen}
        handleClose={() => setObsOpen(false)}
        tramo={selectedTramo}
        observaciones={observacionesState}
        handleSubmit={handleSubmitObservacion}
      />
      <RechazarDialogPT
        open={rechazarOpen}
        handleClose={() => setRechazarOpen(false)}
        tramo={selectedTramo}
        motivosRechazo={motivosRechazo}
        handleSubmit={handleSubmitRechazar}
      />
      <MarcarNegativoDialogPT
        open={negativoOpen}
        handleClose={() => setNegativoOpen(false)}
        tramo={selectedTramo}
        motivosNegativo={motivosNegativo}
        handleSubmit={handleSubmitNegativo}
      />
      <FormContainer />
    </>
  );
};

export default BuscarTramosContainerPT;
